export default __webpack_public_path__ + "static/media/bg.3342df98.jpg";